import classnames from 'classnames';
import { Link as UILink } from 'components/ui';
import { useAnalytics } from 'hooks';
import PropTypes from 'prop-types';
import React, { useCallback } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { getBasePathname } from 'utilities/huggg';
import { getFooterLink } from 'utilities/links';
import styles from './card.module.scss';

const CardFooter = ({ huggg, segment }) => {
  const analytics = useAnalytics();
  const onTermsClick = useCallback(() => {
    analytics.buttonClickFooterTerms();
  }, [analytics]);
  const onPrivacyClick = useCallback(() => {
    analytics.outboundLinkHugggPrivacy();
  }, [analytics]);

  const partnerTerms = getFooterLink(segment, 'partnerTerms');
  const privacyPolicy = getFooterLink(segment, 'privacyPolicy');

  const configuredLink = (link, onClick) => (
    <UILink.BaseLink
      className={styles.linkListLink}
      href={link.href}
      key={null}
      newWindow={true}
      onClick={onClick}
    >
      {link.label}
    </UILink.BaseLink>
  );

  const links = [
    partnerTerms.render &&
      (partnerTerms.link
        ? configuredLink(partnerTerms.link, onTermsClick)
        : huggg.id && (
            <RouterLink
              className={styles.linkListLink}
              key={null}
              onClick={onTermsClick}
              to={`${getBasePathname(huggg)}/partner-terms`}
            >
              Terms & Conditions
            </RouterLink>
          )),
    privacyPolicy.render &&
      (privacyPolicy.link ? (
        configuredLink(privacyPolicy.link, onPrivacyClick)
      ) : (
        <UILink.HugggPrivacy className={styles.linkListLink} key={null} />
      )),
  ]
    .filter((_) => _)
    .flatMap((link, index) =>
      index === 0
        ? [link]
        : [
            <div className={styles.linkListSeparator} key={null}>
              |
            </div>,
            link,
          ],
    );

  return (
    <nav
      className={classnames(styles.footerNav, 'u-font-smallest')}
      data-test-id="footer-navigation"
    >
      <ul className={styles.linkList}>
        {links.map((link, index) => (
          <li className={styles.linkListItem} key={index}>
            {link}
          </li>
        ))}
      </ul>
    </nav>
  );
};

CardFooter.propTypes = {
  huggg: PropTypes.object.isRequired,
  segment: PropTypes.object,
};

export default CardFooter;
